import React from 'react';
import { FadeIn } from './FadeIn';
export function PainSection() {
  return <section className="bg-brand-cream py-16 md:py-24 px-4 md:px-6" data-id="element-67">
      <div className="max-w-3xl mx-auto" data-id="element-68">
        <FadeIn data-id="element-69">
          <p className="text-[11px] font-semibold tracking-[0.14em] uppercase text-brand-green mb-3" data-id="element-70">
            Seamos directas un segundo
          </p>
          <div className="w-12 h-[2px] bg-brand-green mb-8 md:mb-10" data-id="element-71" />

          <div className="text-brand-muted text-[17px] md:text-xl leading-[1.8] space-y-6 max-w-2xl" data-id="element-72">
            <p data-id="element-73">
              Elegiste fonoaudiología porque te apasiona. Porque querés
              acompañar el proceso de un nene que empieza a hablar, de un
              paciente que recupera la voz, de una familia que finalmente
              entiende qué le pasa a su hijo.
            </p>
            <p data-id="element-74">
              No elegiste fonoaudiología para quedarte después de las sesiones
              redactando informes para la obra social, llenando planillas de
              asistencia, escribiendo el mismo mensaje de WhatsApp por décima
              vez o buscando en el Word de hace tres meses el modelo de
              anamnesis que usaste una vez.
            </p>
            <p className="font-serif italic text-brand-dark text-2xl md:text-3xl pt-2" data-id="element-75">
              Y sin embargo, ahí estás.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-76">
          <div className="bg-brand-green text-white rounded-lg p-8 md:p-10 mt-10 md:mt-12 relative overflow-hidden" data-id="element-77">
            <span aria-hidden className="absolute top-12 left-5 text-white/15 font-serif leading-none select-none" style={{
            fontSize: '90px'
          }} data-id="element-78">
              "
            </span>
            <p className="relative font-serif italic text-lg md:text-2xl leading-snug" data-id="element-79">
              "Después de las sesiones me quedo escribiendo. Siempre. Lo que más
              me agota no es el trabajo clínico, es todo lo que viene después."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}